module.exports = __webpack_public_path__ + "static/media/image-2.59dcc5df.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Algorithms/image-2.png
// module id = 247
// module chunks = 0